export enum IPageStatus {
  LOADING,
  READY,
}
export interface IPageState {
  status: IPageStatus
}
